import React from "react";
import ReactStars from "react-stars";
import { Button, Col, Container, Label, Modal, Row } from "reactstrap";

export default function TerminationReviewResult(props) {
    const {data, onClose} = props;

    return (
        <Modal
            isOpen={true}
            className="modal-lg"
            modalClassName="db-example-modal-lg"
        >
            <div
                className="modal-header"
            >
                <h5
                    className="modal-title"
                >
                    Employee Performance Rating Details
                </h5>
                <button
                    aria-label="Close"
                    className="close"
                    onClick={onClose}
                    type="button"
                >
                    <span aria-hidden={true}><i className="fas fa-times-circle" /></span>
                </button>
            </div>
            <div
                className="modal-body"
            >
                <Container>
                    <Row>
                    {
                        data.map((c, idx) => {

                            return (
                                <Col className="m-0 p-0" key={`assessment_${idx}`} md={12} lg={6}>
                                    <Row className="m-0 p-0">
                                        <Col className="m-0 p-0" xs={9}>
                                            <Label>
                                            {
                                                c.employeeAssessmentItemName
                                            }
                                            </Label>
                                        </Col>
                                        <Col className="m-0 p-0" xs={3}>
                                        {
                                            c.isYesNo ?
                                            <Label>{c.assessmentValue ? "Yes" : "No"}</Label>
                                            :
                                            <ReactStars
                                                className={"stars-on-profile"}
                                                count={4}
                                                half={false}
                                                size={20}
                                                value={c.assessmentValue ?? 0}
                                                color2={'#ffd700'}
                                                disabled={true}
                                                edit={false}
                                            />
                                        }
                                        </Col>
                                    </Row>
                                </Col>
                            );
                        })
                    }
                    </Row>
                </Container>
            </div>
            <div
                className="modal-footer"
            >
                <Button
                    color="secondary"
                    onClick={onClose}
                    type="button"
                >
                    Close
                </Button>
            </div>
        </Modal>
    );
}
